// Users' `date_of_hire` column is a real formatted date, e.g. "Jan 19, 2026"
// — consistently shaped (unlike `birthday`, which is hand-typed free text),
// since it comes from an actual date-formatted cell. Still parsed loosely
// rather than trusted blindly, same caution as everywhere else this app
// reads a manually-editable sheet.

const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

// Returns { month (0-11), day, year } or null if the text doesn't parse.
export function parseHireDate(raw) {
  if (!raw) return null;
  const m = String(raw)
    .trim()
    .match(/^([A-Za-z]+)\.?\s+(\d{1,2}),?\s+(\d{4})$/);
  if (!m) return null;
  const month = MONTHS.indexOf(m[1].slice(0, 3).toLowerCase());
  if (month === -1) return null;
  const day = parseInt(m[2], 10);
  const year = parseInt(m[3], 10);
  if (day < 1 || day > 31) return null;
  return { month, day, year };
}
